export type {
  YardSpotAssignmentDetails,
  YardSpotDetails,
  YardSpotReserveDetails
} from './yardSpotPresenterShared';

export { useYardSpotFetcher } from './useYardSpotFetcher';
export type { UseYardSpotFetcherOptions } from './useYardSpotFetcher';
export type { UseYardSpotFetcherOptions as UseYardSpotPresenterOptions } from './useYardSpotFetcher';

export { useYardSpotDisplay } from './useYardSpotDisplay';
export type {
  YardSpotDisplayField,
  YardSpotDisplayData,
  UseYardSpotDisplayOptions
} from './useYardSpotDisplay';

import { useYardSpotFetcher } from './useYardSpotFetcher';

import type { UseYardSpotFetcherOptions } from './useYardSpotFetcher';

/**
 * Combined fetch + live-update composable. Delegates to {@link useYardSpotFetcher}.
 * Pair with {@link useYardSpotDisplay} when fetch is owned by a parent (e.g. list row).
 */
export function useYardSpotPresenter(options: UseYardSpotFetcherOptions) {
  return useYardSpotFetcher(options);
}
